import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOptionRequest, ListOption } from '../modules/tcm-core.module';
import { PatientFormsCombinedFileRequest } from '../models/document-templates';
import { DocumentTemplateTypeEnum } from '../models/enums';

@Injectable({
  providedIn: 'root'
})
export class DocumentTemplateDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getTokensByTypeAsync(type: DocumentTemplateTypeEnum): Promise<string[]> {
    return this.httpClient.getJsonAsync<string[]>('DocumentTemplates/GetTokensByType?type=' + type);
  }

  public async downloadPatientFormsAsync(request: PatientFormsCombinedFileRequest): Promise<boolean> {
    try{
      const response = await this.httpClient.getFileAsync(`DocumentTemplates/DownloadPatientForms`, request);
      
      response.save();
      
      return true;
    } catch {
      return false;
    }   
  }

  public getMarketingDocumentTemplateOptionsAsync(query: string, cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('DocumentTemplates/MarketingOptions', request, cancellationToken);
  }

  public generatePatientFormAsync(patientId: number, salesOrderId: number, appointmentId: number, documentTypeId: number, timeout: Promise<any>): Promise<{ patientDocumentId: number }> {
    return this.httpClient.getJsonAsync('DocumentTemplates/GeneratePatientForm', { patientId, salesOrderId, appointmentId, documentTypeId }, timeout);
  }

  public generatePatientQuoteAsync(salesOrderId: number, timeout: Promise<any>): Promise<number> {
    return this.httpClient.postJsonAsync(`DocumentTemplates/GeneratePatientQuote`, salesOrderId, timeout);
  }

  public generateInsuranceQuoteAsync(salesOrderId: number, timeout: Promise<any>): Promise<number> {
    return this.httpClient.postJsonAsync(`DocumentTemplates/GenerateInsuranceQuote`, salesOrderId, timeout);
  }

  public generatePatientInvoiceAsync(salesOrderId: number, timeout: Promise<any>): Promise<number> {
    return this.httpClient.postJsonAsync(`DocumentTemplates/GeneratePatientInvoice`, salesOrderId, timeout);
  }

  public getCustomHeadersDefaultValueAsync(): Promise<string> {
    return this.httpClient.getJsonAsync<string>('DocumentTemplates/GetCustomHeadersDefaultValue');
  }
}
